export const DEFAULT_DATA_SERVER_PATH = '/dataserver';
export const DEFAULT_IMAGESERVER_URL = '/imageserver';
